import React, { useEffect, useRef, useState } from 'react';
import Topbar from '../components/Topbar';
import Leftbar from '../components/Leftbar';
import { Link } from 'react-router-dom';
import { displayError, displaySuccess, getNriUsers } from '../Utils/utils';
import { toggleLoader } from '../actions/loader';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import config from '../config/config';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import './style.css';

const AVATAR_PALETTE = [
  '#5a4cdb', '#d6336c', '#2b6cb0', '#e8590c', '#0ca678',
  '#7048e8', '#c2255c', '#1098ad', '#f08c00', '#37b24d',
];

const colorForName = (name = '') => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
};

const initialsOf = (first = '', last = '') => {
  const f = (first || '').trim();
  const l = (last || '').trim();
  if (f && l) return (f[0] + l[0]).toUpperCase();
  if (f) return f.substring(0, 2).toUpperCase();
  if (l) return l.substring(0, 2).toUpperCase();
  return '?';
};

const ageFromDob = (dob) => {
  if (!dob) return null;
  const years = moment().diff(moment(dob), 'years');
  if (isNaN(years) || years < 0 || years > 130) return null;
  return years;
};

const genderClass = (gender) => {
  const g = (gender || '').toLowerCase();
  if (g === 'female') return 'gender-badge gender-female';
  if (g === 'male') return 'gender-badge gender-male';
  return 'gender-badge gender-other';
};

const journeyStatusClass = (status) => {
  if (status === 'completed') return 'journey-badge journey-completed';
  if (status === 'pending') return 'journey-badge journey-pending';
  return 'journey-badge journey-not-started';
};

const journeyStatusLabel = (status) => {
  if (status === 'not_started') return 'Ongoing';
  if (status === 'pending') return 'Pending';
  if (status === 'completed') return 'Completed';
  return '—';
};

const UsersNriList = (props) => {
  const [users, setUsers] = useState([]);
  const [is_delete, setIsDelete] = useState('');
  const [temp_var_id, setTempVarId] = useState('');
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [genderFilter, setGenderFilter] = useState('all');
  const [journeyFilter, setJourneyFilter] = useState('');
  const searchTimerRef = useRef(null);

  const getList = async (perPage = count, pageNum = 1, journeyStatus = journeyFilter, searchVal = search, genderVal = genderFilter) => {
    props.toggleLoader(true);
    var getUsers_var = await getNriUsers(perPage, pageNum, journeyStatus, searchVal, genderVal);
    setTotal(getUsers_var?.metadata?.totalPage);
    setPage(getUsers_var?.metadata?.page);
    setUsers(getUsers_var.data || []);
    props.toggleLoader(false);
  };

  useEffect(() => {
    getList(count, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteCoupon = async () => {
    var token = localStorage.getItem('token');
    props.toggleLoader(true);
    let path = config.siteUrl;
    axios.get(path + '/delete-provider/' + temp_var_id, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    })
      .then(async () => {
        displaySuccess('Deleted Successfully');
        getList(count, page);
        props.toggleLoader(false);
      })
      .catch(function (error) {
        props.toggleLoader(false);
        displayError(error);
      });
  };

  const handlePageClick = async (e) => {
    props.toggleLoader(true);
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    const selectedPage = e.selected + 1;
    var getUsers_var = await getNriUsers(count, selectedPage, journeyFilter, search, genderFilter);
    setTotal(getUsers_var?.metadata?.totalPage);
    setPage(getUsers_var?.metadata?.page);
    setUsers(getUsers_var.data || []);
    props.toggleLoader(false);
  };

  const handlePerPageChange = (e) => {
    const next = parseInt(e.target.value, 10);
    setCount(next);
    getList(next, 1, journeyFilter, search, genderFilter);
  };

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearch(val);
    clearTimeout(searchTimerRef.current);
    searchTimerRef.current = setTimeout(() => {
      getList(count, 1, journeyFilter, val, genderFilter);
    }, 400);
  };

  const handleGenderChange = (e) => {
    const val = e.target.value;
    setGenderFilter(val);
    getList(count, 1, journeyFilter, search, val);
  };

  const handleJourneyFilterChange = (e) => {
    const val = e.target.value;
    setJourneyFilter(val);
    getList(count, 1, val, search, genderFilter);
  };

  const hasActiveFilter = search || genderFilter !== 'all' || journeyFilter;

  return (
    <>
      <body className="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar />
          <main className="main-content border-radius-lg">
            <Topbar />

            <div className="header bg-primary pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark">
                          <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                          <li className="breadcrumb-item"><a href="#">Users</a></li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card users-card">
                    <div className="users-card-header">
                      <h3 className="users-title">
                        Users Listing
                        <span className="users-count-chip">
                          {users.length}
                        </span>
                      </h3>

                      <div className="users-toolbar">
                        <div className="users-search">
                          <i className="fas fa-search search-icon" />
                          <input
                            type="text"
                            placeholder="Search name, email or phone"
                            value={search}
                            onChange={handleSearchChange}
                          />
                        </div>
                        <div className="users-filter">
                          <select
                            value={genderFilter}
                            onChange={handleGenderChange}
                            aria-label="Filter by gender"
                          >
                            <option value="all">All genders</option>
                            <option value="female">Female</option>
                            <option value="male">Male</option>
                            <option value="other">Other</option>
                          </select>
                        </div>
                        <div className="users-filter">
                          <select
                            value={journeyFilter}
                            onChange={handleJourneyFilterChange}
                            aria-label="Filter by journey status"
                          >
                            <option value="">All statuses</option>
                            <option value="not_started">Ongoing</option>
                            <option value="pending">Pending</option>
                            <option value="completed">Completed</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="users-table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone number</th>
                            <th>DOB</th>
                            <th>Gender</th>
                            <th>Registered on</th>
                            <th>Last Login</th>
                            <th>Journey Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users.map((user) => {
                            const fullName = `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || '—';
                            const initials = initialsOf(user?.first_name, user?.last_name);
                            const avatarColor = colorForName(fullName);
                            const age = ageFromDob(user?.dob);
                            const createdMoment = user?.createdAt ? moment(user.createdAt) : null;
                            const lastLoginMoment = user?.last_login_at ? moment(user.last_login_at) : null;

                            return (
                              <tr key={user._id || user.email}>
                                <td data-label="Name">
                                  <div className="user-name-cell">
                                    <span
                                      className="user-avatar"
                                      style={{ background: avatarColor }}
                                    >
                                      {initials}
                                    </span>
                                    <div className="user-name-block">
                                      <span className="user-name">{fullName}</span>
                                    </div>
                                  </div>
                                </td>
                                <td data-label="Email">
                                  {user?.email ? (
                                    <a href={`mailto:${user.email}`} className="user-email">{user.email}</a>
                                  ) : (
                                    <span className="text-muted">—</span>
                                  )}
                                </td>
                                <td data-label="Phone">
                                  <span className="user-phone">{user?.phone_number || '—'}</span>
                                </td>
                                <td data-label="DOB">
                                  {user?.dob ? (
                                    <>
                                      <span className="user-dob-main">
                                        {moment(user.dob).format('DD MMM YYYY')}
                                      </span>
                                      {age != null && (
                                        <span className="user-dob-age">{age} yrs old</span>
                                      )}
                                    </>
                                  ) : (
                                    <span className="text-muted">—</span>
                                  )}
                                </td>
                                <td data-label="Gender">
                                  {user?.gender ? (
                                    <span className={genderClass(user.gender)}>{user.gender}</span>
                                  ) : (
                                    <span className="text-muted">—</span>
                                  )}
                                </td>
                                <td data-label="Registered">
                                  {createdMoment ? (
                                    <>
                                      <span className="user-registered-main">
                                        {createdMoment.format('DD MMM YYYY')}
                                      </span>
                                      <span className="user-registered-sub">
                                        {createdMoment.format('hh:mm A')} · {createdMoment.fromNow()}
                                      </span>
                                      <span className="user-registered-sub">
                                        {user?.platform || ''}
                                      </span>
                                    </>
                                  ) : (
                                    <span className="text-muted">—</span>
                                  )}
                                </td>
                                <td data-label="Last Login">
                                  {lastLoginMoment ? (
                                    <>
                                      <span className="user-registered-main">
                                        {lastLoginMoment.format('DD MMM YYYY, hh:mm A')}
                                      </span>
                                      {user?.last_login_platform && (
                                        <span className="user-registered-sub">
                                          {user.last_login_platform}
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    <span className="text-muted">—</span>
                                  )}
                                </td>
                                <td data-label="Journey Status">
                                  {user?.journey_status ? (
                                    <span className={journeyStatusClass(user.journey_status)}>
                                      {journeyStatusLabel(user.journey_status)}
                                    </span>
                                  ) : (
                                    <span className="text-muted">—</span>
                                  )}
                                </td>
                                <td data-label="Actions">
                                  <Link
                                    to={`/maternity-user-detail/${user._id}`}
                                    className="ud-view-more-btn"
                                  >
                                    <i className="fas fa-eye" /> View More
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}

                          {!users.length && (
                            <tr>
                              <td colSpan={9}>
                                <div className="users-empty">
                                  <i className="fas fa-users" />
                                  <div className="users-empty-text">No users found</div>
                                  <div className="users-empty-sub">
                                    {hasActiveFilter
                                      ? 'Try adjusting your search or filters'
                                      : 'No users have registered yet'}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {users.length > 0 && (
                      <div className="users-footer">
                        <div className="users-per-page">
                          <span>Rows per page</span>
                          <select value={count} onChange={handlePerPageChange}>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </div>

                        <div className="paginate-css" style={{ margin: 0 }}>
                          <ReactPaginate
                            previousLabel="<"
                            nextLabel=">"
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={total}
                            forcePage={page > 0 ? page - 1 : 0}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {is_delete === true ? (
              <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes"
                confirmBtnBsStyle="danger"
                title="Are you sure?"
                onConfirm={() => {
                  deleteCoupon();
                  setIsDelete(false);
                }}
                onCancel={() => {
                  setIsDelete(false);
                  setTempVarId('');
                }}
                focusCancelBtn
              >
                Do you want to delete this provider?
              </SweetAlert>
            ) : (
              []
            )}
          </main>
        </div>
      </body>
    </>
  );
};

const mapDispatchToProps = {
  toggleLoader,
};
const mapStateToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps)(UsersNriList);
